/**
 * Calculate the number of years since a given start year.
 * For example, if started in 2021 and current year is 2026, returns 5.
 */
export const getYearsSince = (startYear: number): number => {
  const currentYear = new Date().getFullYear();
  return currentYear - startYear;
};

/**
 * Get the experience years string with a "+" suffix.
 * For example, if started in 2021 and current year is 2026, returns "5+".
 */
export const getExperienceYears = (startYear: number): string => {
  const years = getYearsSince(startYear);
  return `${years}+`;
};

/**
 * Calculate the dynamic happy patient count.
 * Starts at 200 and increases by 50 every 6 months from January 1, 2026.
 * Returns the number without "+" sign.
 */
export const getHappyPatientCount = (): number => {
  const baseHappyPatients = 200;
  const patientIncreasePeriodMonths = 6;
  const patientIncreaseAmount = 50;
  const startDate = new Date(2026, 0, 1); // January 1, 2026
  const now = new Date();
  const monthsElapsed = (now.getFullYear() - startDate.getFullYear()) * 12 + (now.getMonth() - startDate.getMonth());
  const sixMonthPeriods = Math.max(0, Math.floor(monthsElapsed / patientIncreasePeriodMonths));
  return baseHappyPatients + sixMonthPeriods * patientIncreaseAmount;
};